import SiteHeader from './components/SiteHeader';
import HeroSection from './components/HeroSection';
import AnchorSpotlight from './components/AnchorSpotlight';
import TopicWall from './components/TopicWall';
import HotRanking from './components/HotRanking';
import CategoryBoards from './components/CategoryBoards';
import UpdateTimeline from './components/UpdateTimeline';
import TrustFaq from './components/TrustFaq';
import SiteFooter from './components/SiteFooter';

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <SiteHeader />
      <main>
        <HeroSection />
        <AnchorSpotlight />
        <TopicWall />
        <HotRanking />
        <CategoryBoards />
        <UpdateTimeline />
        <TrustFaq />
      </main>
      <SiteFooter />
    </div>
  );
}